import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'panel-toggle-button',
  templateUrl: 'panel-toggle-button.component.html',
  styleUrls: ['panel-toggle-button.component.scss'],
})
export class PanelToggleButtonComponent {
  @Input() pointerIcon: boolean = false;
}
